// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__2XD7J","dragIcon":"Choice_dragIcon__1v-UA","left":"Choice_left__oXlwf","input":"Choice_input__2KkWq"};